import { Injectable } from '@angular/core';
import { License } from '../models/license';
import { Observable } from 'rxjs';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { RouterModule, Routes, Router } from '@angular/router';
//import { AppRoutingModule } from '../modules/app-routing.module';  


@Injectable()
export class LicenseService {

  constructor(private _http: Http) { }

  GetVersions(): Observable<any> {    
    return this._http.get('/api/license/GetLicenseVersions')
      .map(this.extractData)
      .catch(this.handleError);
  }

  GetLicenses(): Observable<Array<License>> {    
    return this._http.get('/api/license')
      .map(this.extractData)
      .catch(this.handleError);
  }
 
  GetLicense(id: number): Observable<License> {    
   return this._http.get('/api/license/' + id)
     .map(this.extractData)
     .catch(this.handleError);
 }

 Save(item: License): Observable<License> {    
  return this._http.put('/api/license', item)
    .map(this.extractData)
    .catch(this.handleError);
}

Create(item: License): Observable<License> {    
  return this._http.post('/api/license', item)
    .map(this.extractData)
    .catch(this.handleError);
}

Delete(item: License): Observable<License> {    
  return this._http.delete('/api/license/' + item.Id)
    .map(this.extractData)
    .catch(this.handleError);
}

Email(item: License): Observable<License> {    
  return this._http.post('/api/license/email?id=' + item.Id, null)
    .map(this.extractData)
    .catch(this.handleError);
}

Download(id: number): Observable<any> { 
  return this._http.get('/api/license/download?id=' + id, {responseType: ResponseContentType.Blob})
    .map(response => (<Response>response).blob())
    .catch(this.handleError);
}

 private extractData(res: Response) {
  let data
  if (res.text()) {
    data = res.json();
  }
  return data || {};
}

private handleError(error: Response | any) {
  // In a real world app, we might use a remote logging infrastructure
  let errMsg: string;
  if (error instanceof Response) {
    const body = error.json() || '';
    const err = body.error || JSON.stringify(body);
    errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
  } else {
    errMsg = error.message ? error.message : error.toString();
  }
  console.error(errMsg);
  return Observable.throw(errMsg);
}

}



// WEBPACK FOOTER //
// ./src/app/services/license.service.ts